import styles from './ShortLinkHelper.module.scss'

const ShortLinkHelper = ({ children }) => (
  <div className={styles.helper}>
    <div className={styles.container}>
      <div className={styles.url}>
        <span className={styles.base}>savibook.com/</span>
        <span className={styles.selectionToken}>{children}</span>
      </div>
    </div>
  </div>
)

export default ShortLinkHelper
